import { lazy } from "react";
import LazyLoad from "../common/LazyLoad";
import AuthLayout from "./AuthLayout";
const Login = LazyLoad(lazy(() => import("../pages/auth/Login")));
const Register = LazyLoad(lazy(() => import("../pages/auth/Register")));
const Congratulations = LazyLoad(
  lazy(() => import("../pages/auth/Congratulations"))
);

const AuthRoutes = {
  path: "/",
  element: <AuthLayout />,
  children: [
    {
      path: "/",
      element: <Login />,
    },

    // {
    //   path: "register",
    //   element: <Register />,
    // },
    {
      path: "congratulations",
      element: <Congratulations />,
    },
  ],
};

export default AuthRoutes;
